export default {
  home: {
    buenosDias: "Good morning",
    buenasTardes: "Good afternoon",
    buenasNoches: "Good evening",
    reparaciones: "Repairs",
    servicios: "Services",
    atrasados: "Overdue",
    reclamos: "Requests",
    tituloRep: "Workshop repairs",
    tituloServ: "On-site services",
    verMas: "See more"
  },
  sidebar: {
    dashboard: "Dashboard",
    reparaciones: "Repairs",
    servicios: "Services",
    reclamos: "Requests",
    eliminadas: "Deleted orders",
    clientes: "Clients",
    proveedores: "Suppliers",
    obras: "Works",
    stock: "Stock",
    repuestos: "Spare parts",
    compras: "Purchases",
    remitos: "Delivery notes",
    stockPorSucursal: "Stock by branch",
    familias: "Families",
    equipos: "Equipment",
    listado: "List",
    tiposEquipo: "Equipment types",
    marcas: "Brands",
    modelos: "Models",
    porUbicacion: "By location",
    checklists: "Checklists",
    planesMantenimiento: "Maintenance plans",
    rma: "RMA",
    mantVehicular: "Vehicle maint.",
    despachos: "Dispatches",
    planillaGasoilAceite: "Fuel/oil control sheet",
    cambiosAceite: "Oil changes",
    alertasConsumo: "Consumption alerts",
    proximosMantenimientos: "Upcoming maintenance",
    informes: "Reports",
    habilitaciones: "Certifications",
    planActual: "Current plan",
    vencePlan: "Plan expires on "
  },
  wppCard: {
    titulo: "Whatsapp Module",
    textSubirPlan: "Your SatWeb plan does not include Whatsapp functionality. To use it, you must upgrade to a different plan",
    tituloConfig: "WHATSAPP CONFIGURATION",
    textNumSatweb: "The SatWeb number has been configured for the WhatsApp module",
    textConfig: "Please make sure to configure the WhatsApp module in order to use it",
    comprarNumPropio: "Purchase your own number",
    pregCerrarSesion: "Do you want to log out of WhatsApp?",
    vencido: "Expired",
    vence: "Expires on ",
    servGratis: "Use the free service included in your SatWeb plan",
    nroSatweb: "Messages will be sent to your customers using our WhatsApp number identified as 'SatWeb'",
    nroPropio: "Use your own WhatsApp number",
    txtNroPropio: "Messages will be sent to your customers using your own WhatsApp number",
    gratis: "Free service",
    premium: "Premium service",
    msgError: "The WhatsApp API key or instance ID is invalid. Make sure they are entered correctly"
  },
  calendario: {
    titulo: "Calendar",
    ver: "View calendar",
    msgNoOrdenes: "There are no pending orders for the selected date",
    reparacion: "Repair",
    servicio: "Service",
    cambiarTecnico: "Select another technician",
    totalOrdenes: "Total orders",
    totalRep: "Total repairs",
    totalServ: "Total services"
  },
  tableroMando: {
    titulo: "Control panel",
    nuevasHoy: "New orders today",
    urgentes: "Urgent orders",
    ver: "View dashboard",
    mttr: "MTTR",
    mapaCalor: "Heat map"
  },
  mttr: {
    desc: "MTTR stands for Mean Time To Repair. It represents the average time from when equipment goes out of service (due to scheduled maintenance or a functional failure) to when it is returned to operation.",
    btnEquipo: "Select a piece of equipment",
    año: "Year"
  },
  mapa: {
    titulo: "Where are my technicians?",
    ver: "View map"
  },
  formats: {
    fechaLarga: "dddd, MMMM D, YYYY" 
  }
}
